import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import AdminUpdatePassword from "../components/AdminUpdatePassword/AdminUpdatePassword";
import { updateAdminPassword } from "../actions/adminedit";
import { fetchUserInfo } from "../actions/user";

const mapStateToProps = (state) => {
  return {
    isFetching: state.adminUpdatePassword.isFetching,
    error: state.adminUpdatePassword.error,
    password_otp_enable: state.adminUpdatePassword.password_otp_enable,
    password_session_id: state.adminUpdatePassword.password_session_id,
    
    user_info: state.login.user_info,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUserInfo,
      updateAdminPassword 
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdminUpdatePassword);
